<template>
  <div class="flex flex-col w-full h-full py-2" style="position: relative">
    <v-btn @click="addGlider" v-if="isAloDbFleetFree(modified)">Add Glider</v-btn>
    <div class="grid grid-cols-[auto_auto_auto] gap-5 items-center" v-if="associations">
      <FleetGliderAssociationRow
        v-for="(asso, idx) in associations"
        :class="{ 'bg-[#eeeeee]': idx % 2 == 1 }"
        :association="asso"
        :only-on-going="onlyOnGoing"
        :key="asso.key"
      >
        <v-btn icon @click.prevent="removeAsso(idx)" :title="$t('Fleet.DeleteGliderAssociation')">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </FleetGliderAssociationRow>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import store from '@/store'
import { AloDbFleet, AloDbFleetFormation, isAloDbFleetFormation, isAloDbFleetFree } from '@/models/alodb/AloDbFleet'
import FleetGliderAssociationRow from '@/components/fleet/FleetGliderAssociationRow.vue'

const modified = computed(() => store.myGetters.modifiedAdmAdminFleet as AloDbFleet)

const onlyOnGoing = ref(false)

const associations = ref<{ key: string; gliKey: string | null; misId: number | null; offsets?: [number, number] }[]>([])

function genereAssociation() {
  associations.value = modified.value.param.freeMissionIds?.map((id, idx) => {
    const mis = store.myGetters.missionsById[id]
    return {
      key: `GLIDER${idx + 1}`,
      gliKey: mis?.gliKey?.trim() ?? null,
      misId: mis?.misId ?? id
    }
  })
  modified.value.param.freeMissionIds = associations.value
    .map((asso) => asso.misId!)
    .filter((id) => id != null) as number[]
}

function removeAsso(idx: number) {
  if (!isAloDbFleetFree(modified.value)) return
  associations.value.splice(idx, 1)
  associations.value.forEach((asso, i) => {
    asso.key = `GLIDER${i + 1}`
  })
}

genereAssociation()

function addGlider() {
  if (!isAloDbFleetFree(modified.value)) return
  console.log('addGlider')
  const nextIdx = associations.value.length + 1
  associations.value.push({ key: `GLIDER${nextIdx}`, gliKey: null, misId: null })
}

watch(() => modified.value.FLE_ID, genereAssociation)

watch(
  associations,
  () => {
    modified.value.param.freeMissionIds = associations.value
      .map((asso) => asso.misId!)
      .filter((id) => id != null) as number[]
  },
  { deep: true }
)
</script>
